import { render, staticRenderFns } from "./Infographic6.vue?vue&type=template&id=b2680eac&scoped=true&"
import script from "./Infographic6.vue?vue&type=script&lang=js&"
export * from "./Infographic6.vue?vue&type=script&lang=js&"
import style0 from "./Infographic6.vue?vue&type=style&index=0&id=b2680eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2680eac",
  null
  
)

export default component.exports